import { useSportContext } from '@sorare/core/src/contexts/sport';

import { useRemoveMarketFilterChipEvent } from '#src/hooks/events/useRemoveMarketFilterChipEvent.ts';
import { useFormatFilterWidgetValue } from '#src/hooks/search/useFormatFilterWidgetValue/index.tsx';
import { FilterChip } from '#src/search/ActiveFilters/FilterChip/index.tsx';
import type { RefinementItem } from '#src/search/ActiveFilters/types.ts';

export const ListActiveFilter = ({ item }: { item: RefinementItem }) => {
  const trackRemoveMarketFilterChip = useRemoveMarketFilterChipEvent();
  const { sport } = useSportContext();
  const { formatFilterWidgetValue } = useFormatFilterWidgetValue();

  const labels = formatFilterWidgetValue(item);

  return (
    <>
      {item.refinements.map((refinement, i) => {
        const label = labels[i];

        const refinementValueStr =
          refinement.value === 'string'
            ? refinement.value
            : refinement.value.toString();
        return (
          <FilterChip
            key={refinement.label}
            label={label}
            onClose={() => {
              item.refine(refinement);
              if (sport) {
                trackRemoveMarketFilterChip(
                  item.attribute,
                  typeof label === 'string' ? label : refinementValueStr,
                  sport
                );
              }
            }}
          />
        );
      })}
    </>
  );
};
